import { TravelScratchpad } from '../../domain/scratchpad/TravelScratchpad.js';

const STORAGE_KEY = 'k_tourspot_scratchpad_v1';

/**
 * Infrastructure Repository: LocalStorageScratchpadRepository
 * Handles persistence for TravelScratchpad in PWA / LocalStorage
 */
export class LocalStorageScratchpadRepository {
  /**
   * Load the TravelScratchpad from localStorage
   * @returns {TravelScratchpad}
   */
  static load() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) {
        return new TravelScratchpad();
      }
      const parsed = JSON.parse(raw);
      return TravelScratchpad.fromJSON(parsed);
    } catch (err) {
      console.warn('[ScratchpadRepository] Failed to parse localStorage data:', err);
      return new TravelScratchpad();
    }
  }

  /**
   * Save the TravelScratchpad to localStorage
   * @param {TravelScratchpad} scratchpad
   */
  static save(scratchpad) {
    if (!scratchpad) return;
    try {
      const json = scratchpad.toJSON();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(json));
    } catch (err) {
      console.error('[ScratchpadRepository] Failed to save to localStorage:', err);
    }
  }

  /**
   * Clear all scratchpad data
   */
  static clear() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (err) {
      console.error('[ScratchpadRepository] Failed to clear localStorage:', err);
    }
  }
}
